import { useParams } from "react-router-dom"
import MainTitle from "../../components/template/MainTitle"
import SubTitle from "../../components/template/SubTitle"
import { useEffect, useState } from "react"
import api from "../../components/utils/api"
import TrainingReportTableView from "./TrainingReportTableView"
import TrainingReportGraphView from "./TrainingReportGraphView"
import TrainingReportSummary from "./TrainingReportSummary"

const TrainingReportPage = () => {
    const { id } = useParams()
    const [generalModel, setGeneralModel] = useState(null)
    const [reportData, setReportData] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true)
            try {
                const [generalModelRes, reportDataRes] = await Promise.all([
                    api.get(`/api/general-models/${id}`),
                    api.get(`/api/general-models/${id}/training-report`)
                ])
                setGeneralModel(generalModelRes.data)
                setReportData(reportDataRes.data.data)
            } catch (err) {
                console.error(err)
            } finally {
                setIsLoading(false)
            }
        }
        if (id) {
            fetchData()
        }
    }, [id])

    const renderContent = () => {
        if (isLoading) {
            return <div className="my-5">Loading...</div>
        }
        if (!generalModel) {
            return <div className="my-5">Training report not found.</div>
        }
        if (reportData.length === 0) {
            return null
        }
        return (
            <div className="grid gap-4 mt-5">
                <TrainingReportSummary data={reportData} />
                <TrainingReportGraphView data={reportData} />
                <TrainingReportTableView data={reportData} />
            </div>
        )
    }

    return (
        <div className='default-background'>
            <SubTitle title="Training Report" />
            <MainTitle title={generalModel?.name ?? ''} />
            {renderContent()}
        </div>
    )
}

export default TrainingReportPage
